import { Text } from "@mantine/core";
import classes from "./emptyState.module.scss";

/**
 * Shared empty-state text primitive.
 *
 * Single source of truth for the "no results" wording and styling used
 * across the app — both inside tables (via <TableNoResults>) and in
 * non-table contexts (e.g. an accordion's empty state, a popup list).
 *
 * @param {string} [message]    Text to display. Defaults to "No results found".
 * @param {string} [className]  Optional extra class for layout tweaks at the call site.
 */
export function EmptyState({ message = "No results found", className }) {
  return (
    <Text
      component="div"
      className={
        className ? `${classes["empty-state"]} ${className}` : classes["empty-state"]
      }
    >
      {message}
    </Text>
  );
}

export default EmptyState;
